import * as React from 'react';
if (process.env.BROWSER) {
    require('./index.less');
}
export interface IEmojiProp {
    urlPrefix: string;
    message: string;
}
export default class Emoji extends React.PureComponent<IEmojiProp> {
    public render(): JSX.Element {
        return <>
           {
               this.parseEmojiContent()
           }
        </>;
    }

    private parseEmojiContent() {
        if (!this.props.message) {
            return '';
        }
        return this.props.message.split(/(\[.*?\])(?!\.webp\")/).map((item) => {
                if (/(\[.*?\])(?!\.webp\")/.test(item)) {
                    return <img key={Math.random() + ''}
                    className={'emoji'} src ={`${this.props.urlPrefix}/${item}.webp`} />;
                } else {
                    return item;
                }
         });
    }
}
